import React, { useMemo } from "react";

import useCouponForm from "hooks/useCouponForm";

import CouponFormSteps from "./couponForm/CouponFormSteps";
import CouponFormSidebar from "./couponForm/CouponFormSidebar";
import { createCouponFormFieldRenderers } from "./couponForm/useCouponFormFieldRenderers";
import styles from "./CouponForm.module.scss";

const CouponForm = ({
  mode = "create",
  initialValues,
  onSubmit,
  isSubmitting = false,
}) => {
  const form = useCouponForm({ mode, initialValues, onSubmit, isSubmitting });

  const renderers = useMemo(
    () =>
      createCouponFormFieldRenderers({
        mode: form.mode,
        values: form.values,
        errors: form.errors,
        updateField: form.updateField,
        isView: form.isView,
      }),
    [form.mode, form.values, form.errors, form.updateField, form.isView]
  );

  return (
    <div className={styles.page}>
      <div className={styles.layout}>
        <div className={styles.formColumn}>
          <div className={styles.formCard}>
            <CouponFormSteps form={form} renderers={renderers} />
          </div>
        </div>
        <CouponFormSidebar form={form} />
      </div>
    </div>
  );
};

export default CouponForm;
